import { TextNotesStatus } from "../../../../enums/textNotesStatus";

export const allTextNoteOptions = [
  { label: "Signed", value: TextNotesStatus.COMPLETED },
  { label: "Unsigned", value: TextNotesStatus.UPLOADED_UNSIGNED },
  { label: "Started", value: TextNotesStatus.INITIATED },
  { label: "In Progress", value: TextNotesStatus.IN_PROGRESS },
  { label: "Error", value: TextNotesStatus.FAILED },
  { label: "NA", value: TextNotesStatus.NOT_APPLICABLE },
  { label: "Not Started", value: TextNotesStatus.NOT_INITIATED },
];
